(() => {
  const skipButton = document.querySelector('[data-live-chat-skip]');
  const announcer = document.getElementById('live-chat-announcer');

  if (!skipButton) {
    return;
  }

  const iframeTitle = skipButton.dataset.liveChatIframeTitle || 'Live chat';
  const openedMessage =
    skipButton.dataset.liveChatOpenedMessage || `${iframeTitle} opened.`;
  let widgetOpenedHandlerBound = false;
  let focusAttemptInterval = null;

  const FOCUS_ATTEMPT_MS = 100;
  const FOCUS_ATTEMPT_MAX = 50;

  function getFcWidgetIframe() {
    return document.getElementById('fc_widget');
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isChatOpen() {
    const launcher = document.querySelector('.hotline-launcher.h-open');
    const iframe = getFcWidgetIframe();
    return Boolean((launcher && isVisible(launcher)) || (iframe && isVisible(iframe)));
  }

  function announceChatOpened() {
    if (!announcer) {
      return;
    }

    announcer.textContent = '';
    window.requestAnimationFrame(() => {
      announcer.textContent = openedMessage;
    });
  }

  function tryFocusFcWidget() {
    const iframe = getFcWidgetIframe();

    if (!iframe || !isChatOpen() || !isVisible(iframe)) {
      return false;
    }

    skipButton.blur();

    iframe.setAttribute('title', iframeTitle);
    iframe.setAttribute('tabindex', '-1');

    const launcher = iframe.closest('.hotline-launcher.h-open');
    if (launcher) {
      launcher.setAttribute('tabindex', '-1');
      launcher.focus({ preventScroll: false });
    }

    iframe.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    iframe.focus({ preventScroll: false });

    if (document.activeElement !== iframe) {
      iframe.tabIndex = 0;
      iframe.focus({ preventScroll: false });
      iframe.tabIndex = -1;
    }

    try {
      iframe.contentWindow?.focus();
    } catch (_error) {
      /* cross-origin */
    }

    if (document.activeElement === iframe) {
      announceChatOpened();
      return true;
    }

    return false;
  }

  function scheduleFocusAttempts() {
    if (focusAttemptInterval) {
      window.clearInterval(focusAttemptInterval);
    }

    let attempts = 0;

    focusAttemptInterval = window.setInterval(() => {
      attempts += 1;

      if (tryFocusFcWidget() || attempts >= FOCUS_ATTEMPT_MAX) {
        window.clearInterval(focusAttemptInterval);
        focusAttemptInterval = null;

        if (attempts >= FOCUS_ATTEMPT_MAX && isChatOpen()) {
          announceChatOpened();
        }
      }
    }, FOCUS_ATTEMPT_MS);
  }

  function bindWidgetOpenedHandler(widget) {
    if (!widget || widgetOpenedHandlerBound || typeof widget.on !== 'function') {
      return;
    }

    widgetOpenedHandlerBound = true;

    widget.on('widget:opened', () => {
      window.requestAnimationFrame(() => {
        tryFocusFcWidget();
        scheduleFocusAttempts();
      });
    });
  }

  function openChatWidget() {
    const widget = window.fcWidget;

    if (widget && typeof widget.open === 'function') {
      bindWidgetOpenedHandler(widget);
      widget.open();
      return true;
    }

    const launcher =
      document.querySelector('.fc-widget-normal') ||
      document.querySelector('.hotline-launcher:not(.h-open)') ||
      document.querySelector('#fc_frame');

    if (launcher) {
      launcher.click();
      return true;
    }

    return false;
  }

  function watchForFcWidgetInsertion() {
    const observer = new MutationObserver(() => {
      if (!getFcWidgetIframe()) {
        return;
      }

      observer.disconnect();

      const iframe = getFcWidgetIframe();
      iframe?.addEventListener('load', () => tryFocusFcWidget(), { once: true });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  bindWidgetOpenedHandler(window.fcWidget);
  watchForFcWidgetInsertion();

  skipButton.addEventListener('click', (event) => {
    event.preventDefault();

    if (!openChatWidget()) {
      return;
    }

    scheduleFocusAttempts();
  });
})();
